var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-menu",
    {
      staticClass: "el-menu-vertical-admin",
      attrs: { "default-active": "2", "active-text-color": "#ffd04b" },
      on: { open: _vm.handleOpen, close: _vm.handleClose }
    },
    [
      _c(
        "el-menu-item",
        { attrs: { index: "1-1" }, on: { click: _vm.addUser } },
        [
          _c("i", { staticClass: "el-icon-circle-plus" }),
          _c("span", [_vm._v("Προσθήκη Εσωτερικού Χρήστη")])
        ]
      ),
      _c(
        "el-menu-item",
        { attrs: { index: "1-2" }, on: { click: _vm.addForeignUser } },
        [
          _c("i", { staticClass: "el-icon-circle-plus" }),
          _c("span", [_vm._v("Προσθήκη Αλλοδαπού Χρήστη")])
        ]
      ),
      _c(
        "el-menu-item",
        { attrs: { index: "1-5" }, on: { click: _vm.addNewUniversity } },
        [
          _c("i", { staticClass: "el-icon-circle-plus" }),
          _c("span", [_vm._v("Διαχειριστικό Ιδρυμάτων (Νέων)")])
        ]
      ),
      _c(
        "el-menu-item",
        { attrs: { index: "1-3" }, on: { click: _vm.addUniversity } },
        [
          _c("i", { staticClass: "el-icon-circle-plus" }),
          _c("span", [_vm._v("Διαχειριστικό Ιδρυμάτων (Παλιών)")])
        ]
      ),
      _c(
        "el-menu-item",
        { staticClass: "block", attrs: { index: "1-4" } },
        [
          _c("el-cascader", {
            directives: [
              {
                name: "loading",
                rawName: "v-loading",
                value: _vm.loadingInternalUsers,
                expression: "loadingInternalUsers"
              }
            ],
            attrs: {
              placeholder: "Εύρεση Χρήστη",
              options: _vm.usersNameLabels,
              filterable: "",
              "change-on-select": "change-on-select",
              size: "large",
              "expand-trigger": "click"
            },
            on: { change: _vm.modifyUser }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-submenu",
        {
          directives: [
            {
              name: "loading",
              rawName: "v-loading",
              value: _vm.loadingInternalRoles,
              expression: "loadingInternalRoles"
            }
          ],
          attrs: { index: "2" },
          on: { click: _vm.handleOpen }
        },
        [
          _c("template", { slot: "title" }, [
            _c("i", { staticClass: "el-icon-menu" }),
            _c("span", [_vm._v("Ρόλοι")])
          ]),
          _vm._l(_vm.roles, function(role) {
            return _c(
              "el-menu-item",
              {
                key: role.id,
                staticClass: "admin-menu-item",
                staticStyle: { "padding-left": "10px" },
                attrs: { index: _vm.roleIndexId(role.id) },
                on: {
                  click: function($event) {
                    _vm.modifyRole(role.id)
                  }
                }
              },
              [_vm._v(_vm._s(role.gr_name))]
            )
          })
        ],
        2
      ),
      _c(
        "el-menu-item",
        { attrs: { index: "1000" }, on: { click: _vm.toggleSearch } },
        [
          _c("template", { slot: "title" }, [
            _c("i", { staticClass: "el-icon-search" }),
            _c("span", [_vm._v("Αναζήτηση Αιτήσεων")])
          ])
        ],
        2
      ),
      _c(
        "el-menu-item",
        { attrs: { index: "1003" }, on: { click: _vm.toggleUniSearch } },
        [
          _c("template", { slot: "title" }, [
            _c("i", { staticClass: "el-icon-search" }),
            _c("span", [_vm._v("Αναζήτηση Ιδρυμάτων")])
          ])
        ],
        2
      ),
      _c(
        "el-menu-item",
        { attrs: { index: "1001" }, on: { click: _vm.toggleForeignSearch } },
        [
          _c("template", { slot: "title" }, [
            _c("i", { staticClass: "el-icon-search" }),
            _c("span", [_vm._v("Αναζήτηση Αλλοδαπών Χρηστών")])
          ])
        ],
        2
      ),
      _c(
        "el-menu-item",
        { attrs: { index: "1002" }, on: { click: _vm.toggleStats } },
        [
          _c("template", { slot: "title" }, [
            _c("i", { staticClass: "el-icon-search" }),
            _c("span", [_vm._v("Στατιστικά Αιτήσεων")])
          ])
        ],
        2
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-31cfa90a", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-31cfa90a","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/roleSpecific/AdminMenu.vue
// module id = null
// module chunks = 